<script lang="ts">
	import Button from '../../Button.svelte';
	export let options = [];
	export let educationGroups = [];

	function onIncomeClick(ageGrp: string, event: Event) {
		event.preventDefault();
		if (educationGroups.some((item) => item === ageGrp)) {
			educationGroups = educationGroups.filter((item) => item !== ageGrp);
		} else {
			const neweducationGroups = [...educationGroups, ageGrp];
			educationGroups = options.filter((item) => neweducationGroups.includes(item));
		}
	}

	function onAnyClick(event: Event) {
		event.preventDefault();
		educationGroups = options.length === educationGroups.length ? [] : options;
	}
</script>

<Button
	margin
	variant={options.length === educationGroups.length || educationGroups.length === 0
		? 'raised'
		: 'outlined'}
	on:click={onAnyClick}
>
	any
</Button>
{#each options as ageGrp}
	<Button
		margin
		variant={educationGroups.some((x) => x === ageGrp) ? 'raised' : 'outlined'}
		on:click={(e) => onIncomeClick(ageGrp, e)}
	>
		{ageGrp}
	</Button>
{/each}
